import { render, staticRenderFns } from "./feeDetailSub.vue?vue&type=template&id=42fab638&scoped=true"
import script from "./feeDetailSub.vue?vue&type=script&lang=js"
export * from "./feeDetailSub.vue?vue&type=script&lang=js"
import style0 from "./feeDetailSub.vue?vue&type=style&index=0&id=42fab638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fab638",
  null
  
)

export default component.exports